import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datasource',
  templateUrl: './datasource.component.html',
  styleUrls: ['./datasource.component.css']
})
export class DatasourceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
